import { IonButton, IonLoading, IonText, IonToast } from "@ionic/react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSync } from "../../../store/attendance/actions/getSync";
import { RootState } from "../../../store/rootReducer";

export const SyncSelector = () => {
  const dispatch = useDispatch();
  const getStatusSync = useSelector((state: RootState) => state.attendance.getStatusSync);
  const syncDetails = useSelector((state: RootState) => state.attendance.reportSync);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const launchSyncProcess = async () => {
    try {
      await dispatch(getSync());
      setToastMessage("Sincronización exitosa");
    } catch (error) {
      setToastMessage("Error en la sincronización");
    } finally {
      setShowToast(true);
    }
  };

  return (
    <>
      <IonText class="ion-text-center">
        <h4>Sincronización con sistema de asistencia</h4>
      </IonText>
      <br />
      <IonButton disabled={getStatusSync === "pending"} expand="block" onClick={launchSyncProcess}>
        Ejecutar Sincronización
      </IonButton>
      <br />
      {!syncDetails.status && <span>Este proceso puede durar algunos minutos</span>}

      <IonLoading isOpen={getStatusSync === "pending"} message={"Ejecutando sincronización"} />
      <IonToast
        isOpen={showToast}
        message={toastMessage}
        duration={2000}
        onDidDismiss={() => setShowToast(false)}
      />
      {syncDetails.status && (
        <div>
          <p>Duración total: {syncDetails.totalDuration}</p>
        </div>
      )}
    </>
  );
};
